// extracted by mini-css-extract-plugin
export var actionButton = "_sa-0";
export var actionMenuContainer = "_sa-i";
export var bubble = "_sa-2";
export var bubbleActionMenu = "_sa-j";
export var bubbleContext = "_sa-6";
export var bubbleItems = "_sa-7";
export var customer = "_sa-3";
export var divider = "_sa-8";
export var fileList = "_sa-9";
export var hiddenComment = "_sa-o";
export var infoAbove = "_sa-a";
export var internal = "_sa-4";
export var lightActionButton = "_sa-1";
export var link = "_sa-b";
export var merchant = "_sa-5";
export var message = "_sa-c";
export var profilePicture = "_sa-e";
export var quillToolbarContainer = "_sa-f";
export var senderDate = "_sa-g";
export var senderDateCustomer = "_sa-h";
export var senderName = "_sa-d";
export var time = "_sa-k";
export var uploadedImage = "_sa-l";
export var username = "_sa-m";
export var xsmall = "_sa-n";